export default __webpack_public_path__ + "a1f10b68952eb4ecbc846ddccaaf6cac.png";